import { render, staticRenderFns } from "./RenewalList.vue?vue&type=template&id=310c750a"
import script from "./RenewalList.vue?vue&type=script&lang=js"
export * from "./RenewalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports